import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'store';
import { Box, CircularProgress, Button } from '@mui/material';
import { green } from '@mui/material/colors';
import AnimateButton from 'ui-component/extended/AnimateButton';

const LoadingButton = ({ text, setSuccess }) => {
  const [loading, setLoading] = useState(false);
  const timer = useRef();

  useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    };
  }, []);

  const handleButtonClick = () => {
    if (!loading) {
      setSuccess(false);
      setLoading(true);
      timer.current = window.setTimeout(() => {
        setSuccess(true);
        setLoading(false);
        // Here you might want to dispatch an action or call a method to perform some side effect
        // e.g. dispatch(openSnackbar({ message: 'Brand added', severity: 'success' }));
      }, 1000);
    }
  };

  return (
    <Box sx={{ m: 1, position: 'relative' }}>
      <AnimateButton>
        <Button fullWidth variant="contained" type="submit" disabled={loading} onClick={handleButtonClick}>
          {text}
        </Button>
      </AnimateButton>
      {loading && (
        <CircularProgress
          size={24}
          sx={{
            color: green[500],
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: '-12px',
            marginLeft: '-12px',
          }}
        />
      )}
    </Box>
  );
};

export default LoadingButton;
